import requireReset from '../Services/requireReset'

export default () => (dispatch) => {
  
  dispatch(requireReset())

}
